export default "__VITE_ASSET__Cngpv6sM__"